module.exports = __webpack_public_path__ + "img/jesus_main.deabdd12.png";